import React, { memo } from 'react'
import { useDragLayer } from 'react-dnd'

import { devicesIconComponent } from 'constants/deviceTypeConstants'

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 1060,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
}

function getItemStyles(initialOffset, currentOffset) {
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none',
    }
  }
  let { x, y } = currentOffset

  const transform = `translate(${x}px, ${y}px)`
  return {
    transform,
    WebkitTransform: transform,
  }
}

export const DragLayerComponent = memo(() => {
  const collectedProps = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }))

  const Icon = devicesIconComponent[collectedProps?.item?.icon]?.ComponentIcon

  if (!collectedProps.isDragging) return null

  return (
    <div style={layerStyles}>
      <div
        className={'device_custom_layer'}
        style={{
          ...getItemStyles(
            collectedProps.initialOffset,
            collectedProps.currentOffset
          ),
        }}
      >
        <Icon
          className="device_item_icon"
          color={collectedProps?.item?.color}
        />
        <span
          className="device_item_name"
          style={{
            color: collectedProps?.item?.color,
          }}
        >
          {collectedProps?.item?.name}
        </span>
      </div>
    </div>
  )
})

export default DragLayerComponent
